import { render } from "./PageShowComponent.vue?vue&type=template&id=7d53a7a2"
import script from "./PageShowComponent.vue?vue&type=script&lang=js"
export * from "./PageShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Page/PageShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d53a7a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d53a7a2', __exports__)) {
    api.reload('7d53a7a2', __exports__)
  }
  
  module.hot.accept("./PageShowComponent.vue?vue&type=template&id=7d53a7a2", () => {
    api.rerender('7d53a7a2', render)
  })

}


export default __exports__